import { createContext, useContext, useEffect, useState } from "react";
import { api, errText } from "../lib/api";
import { toast } from "sonner";
import { can as canCheck, hasFeature as hasFeatureCheck, canPick as canPickCheck, PERMISSIONS } from "../lib/permissions";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch { return null; }
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (identifier, password, otp) => {
    try {
      const payload = { identifier, password };
      if (otp) payload.otp = otp;
      const { data } = await api.post("/auth/login", payload);
      // iter114 — 2FA gerekiyor
      if (data.step === "2fa") {
        return { need2fa: true, message: data.message, hint: data.hint, delivery: data.delivery };
      }
      if (data.token) localStorage.setItem("token", data.token);
      setUser(data.user);
      toast.success("Giriş başarılı");
      return { ok: true };
    } catch (e) {
      toast.error(errText(e));
      return { ok: false };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("token");
    setUser(false);
  };

  const can = (action) => canCheck(user, action);
  // iter178 F5 — feature flag helper (UI Shutter)
  const hasFeature = (featureKey) => hasFeatureCheck(user, featureKey);
  // iter178 F4 — pick helper (İşlem Yap ama Görme)
  const canPick = (module) => canPickCheck(user, module);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can, hasFeature, canPick, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
